<template>
	<div class="sub-title" :class="{ 'gray': gray}">
		<div class="top">
			<span>{{ topTitle }}</span>
			<p>{{ title }}</p>
			<img src="../assets/nav-current.png">
		</div>
		<div class="sub-title-content" style="line-height: 1.875rem;" v-html="content">
			<!-- BitFF 是全球领先的一站式超算云服务平台 -->
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'SubTitle',
	props: {
		topTitle: String,
		title: String,
		content: String,

	},
	computed: {
		...mapState(['gray'])
	},
}
</script>

<style scoped>
.sub-title {
	/* color: #38404e; */
}

.sub-title .top p,
.sub-title span {
	font-size: 1.875rem;
}

.sub-title .top {
	position: relative;
	/* margin-bottom: -1.25rem; */
}

.sub-title .top span {
	color: #FFFFFF !important;
	opacity: 0.4;
}

.sub-title .top img {
	position: absolute !important;
	bottom: 0.3125rem !important;
}

.sub-title .top p {
	position: relative !important;
	top: -16px !important;
}

.sub-title-content {
	min-height: 52px;
	line-height: 1.5em !important;
	font-size: 16px !important;
	/* overflow: hidden;
		overflow: hidden; */
	text-overflow: ellipsis;
	display: -webkit-box;
	/* -webkit-line-clamp: 2; */
	/*! autoprefixer: off */
	/* -webkit-box-orient:vertical; */
	/* autoprefixer: on */
}

@media screen and (max-width:480px) {
	.sub-title {
		text-align: center;
	}

	.sub-title .top img {
		/* position: absolute !important;
			bottom: 0.3125rem !important; */
		left: 35%;
		/* margin: 0 auto; */
	}
}
</style>
